import * as React from 'react';
import Spinner from '../Spinner/Spinner';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'md' | 'sm' | 'lg' | 'icon';
  isLoading?: boolean;
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = '', children, isLoading, ...props }, ref) => {
    const baseClass = 'iLendingCDX-button';
    const variantClass = `iLendingCDX-button--${variant}`;
    const sizeClass = `iLendingCDX-button--${size}`;
    const classNames = `${baseClass} ${variantClass} ${sizeClass} ${className || ''}`;

    return (
      <button
        ref={ref}
        className={classNames}
        disabled={isLoading}
        {...props}
      >
        <span className="iLendingCDX-button__text">{children}</span>
        {isLoading && <Spinner className="iLendingCDX-button__spinner " />}
      </button>
    );
  }
);

export { Button };
